import Icon from '@material-ui/icons/Person';
import PasswordIcon from '@material-ui/icons/VpnKey';
import moment from 'moment';
import React from 'react';
import { CreateButton } from '../../buttons';
import { TemporaryPasswordDialog } from '../../components';
import { EditDialog, Filter, NestedResourceList, ResourceList, ResourceShow, Tab, TabbedShowLayout } from '../../controllers';
import { AgeField, BooleanField, CurrentVersionField, DateField, DateTimeField, EditableProjectLinkField, EnumField, ImageField, LinkField, NumberField, ReferenceField, ShareableProjectLinkField, SkillProgressField, TextField, TimeZoneField } from '../../fields';
import { BooleanInput, DateInput, EnumInput, InputGroup, ReferenceInput, SearchInput, TextInput, TimeZoneSelectInput } from '../../inputs';
import projects from '../organizations/users/projects';
import bank_balance_adjustments from './bank_balance_adjustments';
import curriculum_accomplishments from './curriculum_accomplishments';
import followings from './followings';
import friend_requests from './friend_requests';
import keyring_purchases from './keyring_purchases';
import memberships from './memberships';
import mission_achievements from './mission_achievements';

export default {
  Icon,
  menuItems: [
    {
      name: 'Set Temporary Password',
      type: 'component',
      if: user => user.scope === 'child',
      icon: PasswordIcon,
      Component: TemporaryPasswordDialog,
    },
  ],
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <InputGroup
          header="Contact Information"
          subHeader="Name and email information"
        >
          <EnumInput
            source="scope"
          />
          <TextInput
            source="name"
            required
          />
          <TextInput
            source="email"
          />
          {props.record.scope == 'child' && (
            <TextInput
              source="password"
            />
          )}
          <DateInput
            source="date_of_birth"
          />
          <EnumInput
            source="difficulty_level"
          />
        </InputGroup>

        <InputGroup
          header="Influenncer Program"
          subHeader="Members of our Influencer program "
        >
          <BooleanInput
            source="verified"
          />
        </InputGroup>

        <InputGroup
          header="Ambassador Program"
          subHeader="Members of our ambassador program are typically partners, rather than parents. They use different referral codes than regular customers, and are paid in cash for sending us new customers"
        >
          <BooleanInput
            source="ambassador"
          />
        </InputGroup>

        <InputGroup
          header="User Preferences"

        >
          <TimeZoneSelectInput
            choices={[
              {id: 'America/New_York', name: 'Eastern'},
              {id: 'America/Chicago', name: 'Central'},
              {id: 'America/Denver', name: 'Mountain'},
              {id: 'America/Los_Angeles', name: 'Pacific'},

              {id: null, name: 'Other Time Zones', disabled: true},
              {id: 'Africa/Lagos', name: 'Africa/Lagos'},
              {id: 'Africa/Johannesburg', name: 'Africa/Johannesburg'},
              {id: 'America/Bogota', name: 'America/Bogota'},
              {id: 'America/Juneau', name: 'America/Juneau'},
              {id: 'America/Phoenix', name: 'America/Phoenix'},
              {id: 'America/Guyana', name: 'America/Guyana'},
              {id: 'America/Halifax', name: 'America/Halifax'},
              {id: 'Asia/Baghdad', name: 'Asia/Baghdad'},
              {id: 'Asia/Colombo', name: 'Asia/Colombo'},
              {id: 'Asia/Tbilisi', name: 'Asia/Tbilisi'},
              {id: 'Asia/Hong_Kong', name: 'Asia/Hong_Kong'},
              {id: 'Asia/Jerusalem', name: 'Asia/Jerusalem'},
              {id: 'Asia/Kolkata', name: 'Asia/Kolkata'},
              {id: 'Asia/Kuwait', name: 'Asia/Kuwait'},
              {id: 'Asia/Seoul', name: 'Asia/Seoul'},
              {id: 'Asia/Shanghai', name: 'Asia/Shanghai'},
              {id: 'Asia/Singapore', name: 'Asia/Singapore'},
              {id: 'Asia/Taipei', name: 'Asia/Taipei'},
              {id: 'Asia/Tokyo', name: 'Asia/Tokyo'},
              {id: 'Australia/Perth', name: 'Australia/Perth'},
              {id: 'Australia/Sydney', name: 'Australia/Sydney'},
              {id: 'Europe/Copenhagen', name: 'Europe/Copenhagen'},
              {id: 'Europe/Dublin', name: 'Europe/Dublin'},
              {id: 'Europe/Helsinki', name: 'Europe/Helsinki'},
              {id: 'Europe/Istanbul', name: 'Europe/Istanbul'},
              {id: 'Europe/London', name: 'Europe/London'},
              {id: 'Europe/Madrid', name: 'Europe/Madrid'},
              {id: 'Europe/Oslo', name: 'Europe/Oslo'},
              {id: 'Europe/Paris', name: 'Europe/Paris'},
              {id: 'Europe/Stockholm', name: 'Europe/Stockholm'},
              {id: 'Europe/Zurich', name: 'Europe/Zurich'},
              {id: 'Pacific/Auckland', name: 'Pacific/Auckland'},
              {id: 'Pacific/Honolulu', name: 'Pacific/Honolulu'},
            ]}
          />
          <BooleanInput
            source="do_not_email"
            addLabel
          />
        </InputGroup>

        <InputGroup
          header="Avatar"
          subHeader="Choose an avatar for this user."
        >
          <ReferenceInput
            reference="avatars"
            source="avatar_id"
          />
        </InputGroup>

        <InputGroup
          header="Administration"
          subHeader="If this user is a duplicate of another already in the system, select the original user here. This will automatically delete the current user."
        >
          <ReferenceInput
            filer={{has_email: "true"}}
            optionText={users => `${users.name} (${users.email}) - Created ${moment(users.created_at).format('lll')}`}
            reference="users"
            source="duplicate_of_id"
          />
        </InputGroup>
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        {...props}
      >
        <InputGroup
          header="Contact Information"
          subHeader="Name and email information"
        >
          <ReferenceInput
            label="Target Organization"
            optionText={organizations => `${organizations.name} (${organizations.id}) - Created ${moment(organizations.created_at).format('lll')}`}
            shouldRenderSuggestions={(val) => { return val.trim().length > 2 }}
            source="organization_id"
            required
          />
          <EnumInput
            source="scope"
          />
          <TextInput
            source="name"
            required
          />
          <TextInput
            source="email"
          />
          <TextInput
            source="password"
          />
          <DateInput
            source="date_of_birth"
          />
          <EnumInput
            defaultValue="beginner"
            source="difficulty_level"
          />
        </InputGroup>

        <InputGroup
          header="Ambassador Program"
          subHeader="Members of our ambassador program are typically partners, rather than parents. They use different referral codes than regular customers, and are paid in cash for sending us new customers"
        >
          <BooleanInput
            source="ambassador"
          />
        </InputGroup>

        <InputGroup
          header="User Preferences"
        >
          <TimeZoneSelectInput
            choices={[
              {id: 'America/New_York', name: 'Eastern'},
              {id: 'America/Chicago', name: 'Central'},
              {id: 'America/Denver', name: 'Mountain'},
              {id: 'America/Los_Angeles', name: 'Pacific'},

              {id: null, name: 'Other Time Zones', disabled: true},
              {id: 'Africa/Lagos', name: 'Africa/Lagos'},
              {id: 'Africa/Johannesburg', name: 'Africa/Johannesburg'},
              {id: 'America/Bogota', name: 'America/Bogota'},
              {id: 'America/Juneau', name: 'America/Juneau'},
              {id: 'America/Phoenix', name: 'America/Phoenix'},
              {id: 'America/Guyana', name: 'America/Guyana'},
              {id: 'America/Halifax', name: 'America/Halifax'},
              {id: 'Asia/Baghdad', name: 'Asia/Baghdad'},
              {id: 'Asia/Colombo', name: 'Asia/Colombo'},
              {id: 'Asia/Tbilisi', name: 'Asia/Tbilisi'},
              {id: 'Asia/Hong_Kong', name: 'Asia/Hong_Kong'},
              {id: 'Asia/Jerusalem', name: 'Asia/Jerusalem'},
              {id: 'Asia/Kolkata', name: 'Asia/Kolkata'},
              {id: 'Asia/Kuwait', name: 'Asia/Kuwait'},
              {id: 'Asia/Seoul', name: 'Asia/Seoul'},
              {id: 'Asia/Shanghai', name: 'Asia/Shanghai'},
              {id: 'Asia/Singapore', name: 'Asia/Singapore'},
              {id: 'Asia/Taipei', name: 'Asia/Taipei'},
              {id: 'Asia/Tokyo', name: 'Asia/Tokyo'},
              {id: 'Australia/Perth', name: 'Australia/Perth'},
              {id: 'Australia/Sydney', name: 'Australia/Sydney'},
              {id: 'Europe/Copenhagen', name: 'Europe/Copenhagen'},
              {id: 'Europe/Dublin', name: 'Europe/Dublin'},
              {id: 'Europe/Helsinki', name: 'Europe/Helsinki'},
              {id: 'Europe/Istanbul', name: 'Europe/Istanbul'},
              {id: 'Europe/London', name: 'Europe/London'},
              {id: 'Europe/Madrid', name: 'Europe/Madrid'},
              {id: 'Europe/Oslo', name: 'Europe/Oslo'},
              {id: 'Europe/Paris', name: 'Europe/Paris'},
              {id: 'Europe/Stockholm', name: 'Europe/Stockholm'},
              {id: 'Europe/Zurich', name: 'Europe/Zurich'},
              {id: 'Pacific/Auckland', name: 'Pacific/Auckland'},
              {id: 'Pacific/Honolulu', name: 'Pacific/Honolulu'},
            ]}
          />
        </InputGroup>

        <InputGroup
          header="Avatar"
          subHeader="Choose an avatar for this user."
        >
          <ReferenceInput
            reference="avatars"
            source="avatar_id"
          />
        </InputGroup>
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <EnumField
          source="scope"
        />
        <TextField
          source="name"
        />
        <TextField
          source="email"
        />
        <AgeField
          showDateOfBirth
        />
        <TextField
          source="referral_code"
        />
        <BooleanField
          source="verified"
        />
        <BooleanField
          source="ambassador"
        />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TabbedShowLayout>
          <Tab
            label="summary"
          >
            <DateField
              source="created_at"
            />
            <TextField
              source="id"
            />
            <EnumField
              source="scope"
            />
            <TextField
              source="name"
            />
            <TextField
              source="email"
            />
            <AgeField />
            <DateField
              source="date_of_birth"
            />
            <TextField
              source="referral_code"
            />
            <BooleanField
              source="verified"
              addLabel
            />
            <BooleanField
              label="On Temporary Password"
              source="temporary_password"
              addLabel
            />
            <BooleanField
              source="ambassador"
              addLabel
            />
            <TimeZoneField
              source="time_zone"
            />
            <BooleanField
              source="do_not_email"
              addLabel
            />
            <ReferenceField
              reference="avatars"
              source="avatar_id"
              allowEmpty
            >
              <ImageField
                source="file"
              />
            </ReferenceField>

            <NestedResourceList
              reference="memberships"
            >
              <LinkField
                source="organization_id"
              />
              <TextField
                source="badge"
              />
              <EnumField
                source="role"
              />
              <BooleanField
                source="accepted"
              />
            </NestedResourceList>
          </Tab>

          <Tab
            label="Curriculum"
          >
            <LinkField
              source="rank_id"
            />

            <LinkField
              source="guide_rank_id"
            />

            <NestedResourceList
              perPage={10}
              reference="badge_achievements"
            >
              <LinkField
                source="badge_id"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              perPage={10}
              reference="mission_achievements"
            >
              <LinkField
                source="mission_id"
              />
              <LinkField
                parentReference="users"
                parentSource="user_id"
                source="project_id"
              />
              <BooleanField
                source="completed"
              />
              <BooleanField
                source="submitted"
              />
              <BooleanField
                source="failed"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              perPage={10}
              reference="curriculum_accomplishments"
            >
              <LinkField
                source="project_id"
              />
              <LinkField
                displaySource="difficulty_level"
                label="Difficulty Level"
                source="curriculum_activity_id"
              />
              <LinkField
                source="curriculum_activity_id"
              />
              <NumberField
                source="count"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              reference="curriculum_scores"
            >
              <LinkField
                source="skill_id"
              />
              <NumberField
                source="points"
              />
              <SkillProgressField />
            </NestedResourceList>
          </Tab>

          <Tab
            label="Economy"
          >
            <NestedResourceList
              reference="bank_balances"
            >
              <NumberField
                source="coins"
              />
            </NestedResourceList>

            <NestedResourceList
              perPage={10}
              reference="bank_balance_adjustments"
            >
              <LinkField
                reference="users"
                source="adjusted_by_id"
              />
              <NumberField
                source="coins"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              perPage={10}
              reference="keyring_purchases"
            >
              <LinkField
                reference="library_keyrings"
                source="library_keyring_id"
              />
              <NumberField
                source="coins"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              perPage={10}
              reference="keyring_grants"
            >
              <LinkField
                reference="library_keyrings"
                source="library_keyring_id"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

            <NestedResourceList
              perPage={10}
              reference="economy_ledgers"
            >
              <TextField
                source="coins"
              />
              <TextField
                source="mission_achievement_id"
              />
              <TextField
                source="badge_achievement_id"
              />
              <TextField
                source="keyring_purchase_id"
              />
              <DateTimeField
                source="created_at"
              />
            </NestedResourceList>

          </Tab>

          <Tab
            label="Projects"
          >
            <NestedResourceList
              perPage={10}
              reference="projects"
            >
              <TextField
                source="name"
              />
              <DateTimeField
                source="created_at"
              />
              <ImageField
                source="screenshot_2x"
              />
              <TextField
                source="current_kidscript_version"
              />
              <CurrentVersionField />
              <EnumField
                source="visibility"
              />
              <BooleanField
                source="archived"
              />
              <EditableProjectLinkField
                fullUrl
              />
              <ShareableProjectLinkField
                fullUrl
              />
            </NestedResourceList>
          </Tab>

          <Tab
            label="Social"
          >
            <BooleanField
              source="private_profile"
              addLabel
            />
            <TextField
              source="follower_count"
            />
            <TextField
              source="following_count"
            />

            <NestedResourceList
              reference="followings"
            >
              <LinkField
                reference="users"
                source="user_id"
              />
              <LinkField
                reference="users"
                source="following_id"
              />
            </NestedResourceList>
          </Tab>
        </TabbedShowLayout>
      </ResourceShow>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          source="q"
        />
        <EnumInput
          source="scope"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
    memberships,
    curriculum_accomplishments,
    mission_achievements,
    projects,
    friend_requests,
    followings,
    bank_balance_adjustments,
    keyring_purchases
  },
};
